import React from "react";
import { connect } from "react-redux";
import Modal from "reboron/DropModal";
import _ from 'lodash';

import {
    fetchP24Merchants,
    testConnectionP24Merchant,
    fetchP24MerchantPaymentMethods,
    fetchP24MerchantById,
    createMerchant,
    updateMerchant,
    updateMerchantAuthApiKey,
    updateMerchantAuthCrcKey,
    updateMerchantAuthSandboxCrcKey,
    deleteMerchant
} from "../../../actions/p24MerchantActions";

import { PageHeader } from "../../../components/PageHeader";
import LoadingTable from "../../../components/LoadingTable";

import { formatDateTime } from "../../../helpers/utils";

import P24MerchantConnectionTest from "../../../components/p24/P24MerchantConnectionTest";
import P24MerchantPaymentMethods from "../../../components/p24/P24MerchantPaymentMethods";
import P24MerchantForm from "../../../components/p24/P24MerchantForm";
import { getP24MerchantBusinessTypeById } from "../../../constants/P24MerchantBusinessType";
import { P24ImplementationType } from "../../../constants/P24ImplementationType";
import P24MerchantAuthForm from "../../../components/p24/P24MerchantAuthForm";
import P24MerchantAuthApiKey from "../../../components/p24/P24MerchantAuthApiKey";
import P24MerchantAuthSandboxCrcKey from "../../../components/p24/P24MerchantAuthSandboxCrcKey";
import P24MerchantAuthCrcKey from "../../../components/p24/P24MerchantAuthCrcKey";

import { P24MerchantServicesList, checkP24MerchantService, checkAllP24MerchantServices } from "../../../constants/P24MerchantServices";

// Individual styles for the modal, modal content, and backdrop
const modalStyle = {
    //transform: 'rotate(45deg) translateX(-50%)',
    //width: '80%'
    width: '800px',
    //overflowY: 'scroll'
};

const backdropStyle = {
    // backgroundColor: 'red',
};

const contentStyle = {
    // backgroundColor: 'blue',
    height: '100%',
    // height: '700px',
    // overflowY:'auto'
};

//style={{overflowY:'auto', height:'700px'}}

/**
 * Merchanci P24
 */
class P24Merchants extends React.Component {

    state = {
        //wybrany merchant
        selectedMerchant: {},
        //domyśnie rozwinięte wiersze połączeń {index:true}, np {0, true}- oznacza rozwinięcie pierwszero wiersza w tabelce
        //na ten moment wspieramy rozszerzalność tylko jednego wiersza na raz
        expandedRows: {},
        //wybrany typ implementacji
        selectedP24ImplementationType: P24ImplementationType.REST,
        loading: true
    }

    componentDidMount() {

        //ladowanie danych do tabeli
        this.props.fetchP24Merchants();
    }

    /**
    * Kolumny do tabelki
    */
    tableColumns = [
        {
            Header: this.props.formatMessage("p24Merchant.id"),
            accessor: "id",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 80
        },
        {
            Header: this.props.formatMessage("p24Merchant.p24MerchantId"),
            accessor: "p24MerchantId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 120
        },
        {
            Header: this.props.formatMessage("p24Merchant.name"),
            accessor: "name",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" }
        },
        {
            Header: this.props.formatMessage("p24Merchant.nip"),
            accessor: "nip",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 250
        },
        {
            Header: this.props.formatMessage("p24Merchant.pesel"),
            accessor: "pesel",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 250
        },
        {
            Header: this.props.formatMessage("p24Merchant.businessType"),
            id: "businessType",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            accessor: (data) => {
                return getP24MerchantBusinessTypeById(data.businessType).displayText;
            },
        },
        {
            Header: this.props.formatMessage("p24Merchant.email"),
            accessor: "email",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" }
        },
        {
            Header: this.props.formatMessage("p24Merchant.phoneNumber"),
            accessor: "phoneNumber",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" }
        },
        {
            Header: this.props.formatMessage("p24Merchant.p24SandboxServices"),
            id: "p24SandboxServices",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return checkAllP24MerchantServices(data.p24SandboxServices) ? "TAK" : "-";
            }
        },
        {
            Header: this.props.formatMessage("p24Merchant.p24Services"),
            id: "p24Services",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return checkAllP24MerchantServices(data.p24Services) ? "TAK" : "-";
            }
        },
        {
            Header: this.props.formatMessage("p24Merchant.modificationDate"),
            id: "modificationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.modificationDate);
            }
        },
        {
            Header: "",
            Cell: row => (
                <div>
                    <button
                        className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                        onClick={() => this.onRowDeleteClick(row.original)}
                        title="Kasowanie merchanta"
                    >
                        <i className="fas fa-trash-alt" />
                    </button>
                    <button
                        className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                        onClick={() => this.onRowEditClick(row.original)}
                        title="Edycja merchanta"
                    >
                        <i className="far fa-edit" />
                    </button>
                    <button
                        className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                        onClick={() => this.onRowEditAuthClick(row.original)}
                        title="Autoryzacja merchanta"
                    >
                        <i className="fa fa-key" />
                    </button>
                </div>
            )
        },
        {
            expander: true,
            style: { whiteSpace: "unset", textAlign: "center" },
            width: 30,
            sortable: false,
            filterable: false,
            Expander: ({ isExpanded, ...rest }) => {
                return (
                    <div>{isExpanded ? <span className="w3-large w3-text-theme"><i className="fas fa-minus"></i></span> : <span className="w3-large w3-text-theme"><i className="fas fa-plus"></i></span>}</div>
                );
            }
        }
    ];

    /**
    * Sub Komponent, który pojawia się dla wiersza rozrzerzonego
    * 
    * {@param row} model wiersza w tabelce
    */
    subComponent = (row) => {
        return (
            <div className="w3-theme-l4">


                <div className="w3-small">

                    <div className="w3-padding">

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            onClick={() => this.onRowPaymentMethods(row.original)}
                        >
                            Dostępne metody płatności
                        </button>

                    </div>

                    <div className="w3-padding">

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            onClick={() => this.onRowTestConnectionClick(P24ImplementationType.FORM, row.original)}
                        >
                            Test połączenia - FORM <i className="fas fa-wifi" />
                        </button>

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            onClick={() => this.onRowTestConnectionClick(P24ImplementationType.REST, row.original)}
                        >
                            Test połączenia - REST <i className="fas fa-wifi" />
                        </button>

                        <button
                            className="w3-btn w3-theme width200 w3-margin-right"
                            onClick={() => this.onRowTestConnectionClick(P24ImplementationType.SOAP, row.original)}
                        >
                            Test połączenia - SOAP <i className="fas fa-wifi" />
                        </button>

                    </div>

                    <div className="w3-padding">

                        <P24ServiceItemList merchant={row.original} items={P24MerchantServicesList} />

                    </div>


                </div>

            </div>
        )
    }

    /**
     * Akcja na zmianę rozszerzalności w tabelce
     * 
     * W stanie komponentu zapamiętujemy aktualnie rozszerzny wiersz.
     * 
     * Może być tylko jeden rozszerzony wiersz na raz.
     */
    onExpandedChange = (newExpanded, index, event, cellInfo) => {
        let newExpandedRows = {}
        let rowIndex = index[0];
        if (newExpanded[rowIndex] === false) {
            //wiersz odznaczony - ustawiamy index na false
            newExpandedRows = {};
        } else {
            //wiersz zaznaczony - ustawiamy index wiersza na true
            newExpandedRows = { [rowIndex]: true };
        }

        this.setState({
            ...this.state,
            expandedRows: newExpandedRows,
        });

    }

    /**
    *  Akcja po kliknięciu na żądanie o usunięcie merchanta
    */
    onRowDeleteClick = async data => {

        //pobranie merchanta z serwera
        await this.props.fetchP24MerchantById(data.id);

        this.showModalDeleteMerchant();

    };

    /**
    * Akcja po kliknięciu na żądanie o edycje merchanta
    */
    onRowEditClick = async data => {

        //pobranie merchanta z serwera
        await this.props.fetchP24MerchantById(data.id);

        this.showModalUpdateMerchant();
    };

    /**
    * Akcja po kliknięciu na żądanie o edycje merchanta - dane autoryzacyjne
    */
    onRowEditAuthClick = async data => {
        //pobranie merchanta z serwera
        await this.props.fetchP24MerchantById(data.id);

        this.showModalUpdateAuthMerchant();
    }

    /**
    * Obsluga akcji na klik wiersza - formy płatności merchanta
    */
    onRowPaymentMethods = async  merchant => {

        this.setState({
            selectedMerchant: merchant
        })
        try {
            await this.props.fetchP24MerchantPaymentMethods(null, merchant.id);
            //jest ok otwieramy modal
            this.showPaymentMethodsModal();
        }
        catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    };

    /**
     * Obsluga akcji na klik wiersza - testowania połączenia merchanta
     * 
     * @param {P24ImplementationType} p24ImplementationType typ implementacji
     * @param {Object} merchant obiekt merchanta (wybrany wiersz w tabelce)
     */
    onRowTestConnectionClick = async (p24ImplementationType, merchant) => {

        this.setState({
            selectedP24ImplementationType: p24ImplementationType,
            selectedMerchant: merchant
        })

        try {
            await this.props.testConnectionP24Merchant(p24ImplementationType, merchant.id);
            //jest ok otwieramy modal
            this.showTestConnectionModal();
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    };

    /**
    * Obsluga aktualizacji merchanta 
    */
    handleMerchantUpdate = async (restaurantId, merchant) => {

        try {
            await this.props.updateMerchant(merchant);
            //jest ok zamykamy modal
            this.hideModalUpdateMerchant();
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    }

    /**
    * Obsluga aktualizacji danych autoryzacyjnych merchanta - api key 
    */
    handleMerchantAuthApiKeyUpdate = async (merchantAuth) => {

        try {
            await this.props.updateMerchantAuthApiKey(merchantAuth);
            //nie zamykamy modala
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    }

    /**
    * Obsluga aktualizacji danych autoryzacyjnych merchanta - crc key 
    */
    handleMerchantAuthCrcKeyUpdate = async (merchantAuth) => {

        try {
            await this.props.updateMerchantAuthCrcKey(merchantAuth);
            //nie zamykamy modala
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    }

    /**
    * Obsluga aktualizacji danych autoryzacyjnych merchanta - crc key 
    */
    handleMerchantAuthSandboxCrcKeyUpdate = async (merchantAuth) => {

        try {
            await this.props.updateMerchantAuthSandboxCrcKey(merchantAuth);
            //nie zamykamy modala
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    }

    /**
    * Obsluga kasowania merchanta 
    */
    handleMerchantDelete = async (restaurantId, merchant) => {

        try {
            await this.props.deleteMerchant(merchant);
            //jest ok zamykamy modal
            this.hideModalDeleteMerchant();
        } catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }

    }

    /**
     * Akcja na wywolanie rejestracji nowego merchanta 
     * 
     * @param {Integer} restaurantId identyfikator restauracji
     * @param {Object} merchant model nowego merchanta
     */
    handleMerchantRegister = async (restaurantId, merchant) => {

        try {
            await this.props.createMerchant(merchant);
            this.hideModalRegisterMerchant();
        }
        catch (error) {
            //jesli blad nie ruszamy modala
            console.log('error', error);
        }
    }

    /**
    * Pokazuje modal rejestracji merchanta
    */
    showModalRegisterMerchant() {
        this.refs.modal_registerMerchant.show();
    }

    /**
     * Chowa modal rejestracji merchanta
     */
    hideModalRegisterMerchant = () => {
        this.refs.modal_registerMerchant.hide();
    };

    /**
    * Pokazuje modal testowania połączenia
    */
    showTestConnectionModal() {
        this.refs.modal_testConnection.show();
    }

    /**
     * Chowa modal testowania połączenia
     */
    hideTestConnectionModal = () => {
        this.refs.modal_testConnection.hide();
    };

    /**
    * Pokazuje modal
    */
    showPaymentMethodsModal() {
        this.refs.modal_paymentMethods.show();
    }

    /**
     * Chowa modal
     */
    hidePaymentMethodsModal = () => {
        this.refs.modal_paymentMethods.hide();
    };

    /**
    * Pokazuje modal z aktualizacją merchanta
    */
    showModalUpdateMerchant() {
        this.refs.modal_updateMerchant.show();
    }

    /**
     * Chowa modal z aktualizacją merchanta
     */
    hideModalUpdateMerchant = () => {
        this.refs.modal_updateMerchant.hide();
    };

    /**
   * Pokazuje modal z aktualizacją autoryzacji merchanta
   */
    showModalUpdateAuthMerchant() {
        this.refs.modal_updateAuthMerchant.show();
    }

    /**
     * Chowa modal z aktualizacją autoryzacji merchanta
     */
    hideModalUpdateAuthMerchant = () => {
        this.refs.modal_updateAuthMerchant.hide();
    };

    /**
   * Pokazuje modal z kasowaniem merchanta
   */
    showModalDeleteMerchant() {
        this.refs.modal_deleteMerchant.show();
    }

    /**
     * Chowa modal z kasowaniem merchanta
     */
    hideModalDeleteMerchant = () => {
        this.refs.modal_deleteMerchant.hide();
    };

    addButton = () => {
        return <button
            className="w3-btn w3-theme-dark"
            onClick={() => this.showModalRegisterMerchant()}
        >
            {this.props.formatMessage("app.p24MerchantPage.addMerchant")}
        </button>

    }

    render() {

        return (
            <div>
                <PageHeader text="app.p24MerchantPage.title" />

                <this.addButton />

                <LoadingTable
                    data={this.props.p24MerchantList}
                    columns={this.tableColumns}
                    loading={false}
                    SubComponent={this.subComponent}
                    onExpandedChange={this.onExpandedChange}
                    expanded={this.state.expandedRows}
                />
                <Modal ref={"modal_registerMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24MerchantForm onSubmit={this.handleMerchantRegister} onCancel={this.hideModalRegisterMerchant} title='Rejestruj merchanta' sumbitText="Rejestruj" cancelText="Anuluj" />
                </Modal>

                <Modal ref={"modal_updateMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24MerchantForm merchant={this.props.p24MerchantById} onSubmit={this.handleMerchantUpdate} onCancel={this.hideModalUpdateMerchant} title="Aktualizacja merchanta" sumbitText="Aktualizuj" cancelText="Anuluj" disabledFields={['p24MerchantId', 'creationType']} />
                </Modal>

                <Modal ref={"modal_updateAuthMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>

                    <P24MerchantAuthForm onSubmit={this.hideModalUpdateAuthMerchant} >

                        <P24MerchantAuthApiKey merchantAuth={_.pick(this.props.p24MerchantById, ['id'])} onSubmit={this.handleMerchantAuthApiKeyUpdate} />

                        {this.props.config.przelewy24Sandbox && <P24MerchantAuthSandboxCrcKey merchantAuth={_.pick(this.props.p24MerchantById, ['id'])} onSubmit={this.handleMerchantAuthSandboxCrcKeyUpdate} />}

                        {!this.props.config.przelewy24Sandbox && <P24MerchantAuthCrcKey merchantAuth={_.pick(this.props.p24MerchantById, ['id'])} onSubmit={this.handleMerchantAuthCrcKeyUpdate} />}

                    </P24MerchantAuthForm>
                </Modal>

                <Modal ref={"modal_deleteMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24MerchantForm merchant={this.props.p24MerchantById} onSubmit={this.handleMerchantDelete} onCancel={this.hideModalDeleteMerchant} title="Czy usunąć merchanta?" sumbitText="Usuń" cancelText="Anuluj" disabledFields={['p24MerchantId', 'creationType']} />
                </Modal>

                <Modal ref={"modal_testConnection"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24MerchantConnectionTest p24ImplementationType={this.state.selectedP24ImplementationType} merchant={this.state.selectedMerchant} p24MerchantTestConnection={this.props.p24MerchantTestConnection} onSubmit={this.hideTestConnectionModal} />
                </Modal>

                <Modal ref={"modal_paymentMethods"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24MerchantPaymentMethods merchant={this.state.selectedMerchant} p24MerchantPaymentMethodList={this.props.p24MerchantPaymentMethodList} onSubmit={this.hidePaymentMethodsModal} />
                </Modal>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    p24MerchantList: state.p24MerchantReducer.p24MerchantList,
    p24MerchantById: state.p24MerchantReducer.p24MerchantById,
    p24MerchantTestConnection: state.p24MerchantReducer.p24MerchantTestConnection,
    p24MerchantPaymentMethodList: state.p24MerchantReducer.p24MerchantPaymentMethodList,
    config: state.flow24ServerReducer.config
});

const mapDispatchToProps = ({
    fetchP24Merchants: fetchP24Merchants,
    testConnectionP24Merchant: testConnectionP24Merchant,
    fetchP24MerchantPaymentMethods: fetchP24MerchantPaymentMethods,
    fetchP24MerchantById: fetchP24MerchantById,
    createMerchant: createMerchant,
    updateMerchant: updateMerchant,
    updateMerchantAuthApiKey: updateMerchantAuthApiKey,
    updateMerchantAuthCrcKey: updateMerchantAuthCrcKey,
    updateMerchantAuthSandboxCrcKey: updateMerchantAuthSandboxCrcKey,
    deleteMerchant: deleteMerchant
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24Merchants);

/**
 * Komponent wyświetlający kolekcję usług
 * 
 * @param {*} items kolekcja logów
 */
const P24ServiceItemList = ({ merchant, items }) => {
    return (
        <div>


            <div className="w3-row">
                <div className="w3-col s4 w3-theme-dark w3-center">
                    <p>Usługa</p>
                </div>
                <div className="w3-col s4 w3-dark-grey w3-center">
                    <p>SANDBOX - serwer testowy Przelewy24</p>
                </div>
                <div className="w3-col s4 w3-dark-grey w3-center">
                    <p>SECURE - serwer produkcyjny Przelewy24</p>
                </div>
            </div>

            {items.map(item => <ServiceItem key={item.id} merchant={merchant} item={item} />)}
        </div>
    )
}

/**
 * Pojedyńcza usługa
 * 
 * @param {*} item  log
 */
const ServiceItem = ({ merchant, item }) => {

    return (

        <div className="w3-row w3-border-bottom w3-border-blue">
            <div className="w3-col s4 w3-theme-l3 w3-center">
                <p>{item.displayText}</p>
            </div>
            <div className="w3-col s4 w3-center">
                <p>{checkP24MerchantService(item, merchant.p24SandboxServices) ? "TAK" : "-"}</p>
            </div>
            <div className="w3-col s4 w3-center">
                <p>{checkP24MerchantService(item, merchant.p24Services) ? "TAK" : "-"}</p>
            </div>
        </div>

    )
}